module.exports = __webpack_public_path__ + "static/media/logo-navbar.3945b3f0.png";